import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MembershipService {

  constructor(private http: HttpClient) { }

  getMembershipByMemberId(id: number) {
    return this.http.get<any>(environment.apiUrl + 'Membership/GetMembershipsByMemberIdAsync/' + id);
  }

  getFakeMembershipByMemberIdForException(id: number) {
    return this.http.get<any>(environment.apiUrl + 'Membership/GetFakeMembershipByMemberIdForException/' + id);
  }

  EndMemberMembership(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'membership/EndMemberMembership', JSON.stringify(data), httpOptions);
  }

  EndMemberMembershipSL(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'membership/EndMemberMembershipSL', JSON.stringify(data), httpOptions);
  }

  getOfficesAndSignsStatusForMembership(data) {
    return this.http.get<any>(environment.apiUrl + 'Membership/GetOfficesAndSignsStatusForMembership/' + data.memberId + '/' + data.institutionId);
  }
}
